import axios from 'axios'
export function queryListRole(data) {
    return axios({
        url: '',
        method: 'post',
        data: data
    })
}



export function findSysRole(data) {
    return axios({
        method: 'post',
        url:'/user/SysRole/list',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function addSysRoleInfo(data) {
    return axios({
        method: 'post',
        url:'/user/SysRole/insert',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function editSysroleInfo(data) {
    return axios({
        method: 'post',
        url:'/user/SysRole/update',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function delSysroleInfo(data) {
    return axios({
        method: 'post',
        url:'/user/SysRole/delete?id='+data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function findRoleMember(data) {
    return axios({
        method: 'post',
        url:'/user/SysRole/findRoleMember',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}
export function findAllMember(data) {
    return axios({
        method: 'post',
        url:'/user/SysRole/findAllMember',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}
export function roleUser(data) {
    return axios({
        method: 'post',
        url:'/user/SysRole/rolesUsers',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}
export function delMember(data) {
    return axios({
        method: 'post',
        url:'/user/SysRole/memberDelete',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function roleFunction(data) {
    return axios({
        method: 'post',
        url:'/user/SysRole/rolesFunctions',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function findRoleFunction(data) {
    return axios({
        method: 'get',
        url:'/user/SysRole/findRoleFunc',
        params: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}
export function findAllFunc(data) {
    return axios({
        method: 'get',
        url:'/user/SysRole/findAllFunc',
        params: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function delFunc(data) {
    return axios({
        method: 'delete',
        url:'/user/SysFunction/funcDelete',
        params: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}